/* eslint-disable eqeqeq */
/* eslint-disable no-unused-vars */
/* eslint-disable array-callback-return */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid,no-undef */

import React, { useMemo, useRef, useState } from "react";
import axios from "axios";
import {
  CollectionSchema,
  getReturnWizSchema,
  ReturnSchema,
} from "../order-form/validationSchema";
import { FormControl, MenuItem, Select } from "@mui/material";
import {
  accessUpdate,
  cancelReturnAccess,
  collectionExtraChage,
  extraMiles,
  orderDetailUpdate,
  returnExtraChage,
} from "../_redux/order/orderCrud";
import {
  fetchBillingCardDetail,
  fetchInvoiceList,
  fetchMyOrderDetailCard,
  fetchMyOrderTimeline,
  fetchNewFlags,
  fetchOrderSummary,
  fetchPaymentInvoice,
  fetchReturnReasons,
} from "../_redux/order/orderAction";
import {
  newOrderCollectionValue,
  newOrderReturnValue,
  orderReturnValue,
} from "../orderUtils";

import { CalendarComponent } from "../../Calendar/calendar-component/CalendarComponent";
import CustomeDialog from "../../../../_metronic/_partials/widgets/alert/CustomeDialog";
import DatePicker from "react-datepicker";
import DiscardDialog from "../../../../_metronic/_partials/widgets/alert/DiscardDialog";
import { DropOff } from "../../Calendar/calendar-component/DropOff";
import { Dropdown } from "react-bootstrap";
import { Form } from "react-bootstrap";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { LoadingCustome } from "../../../../_metronic/_partials/controls/LoadingCustome";
import { Modal } from "react-bootstrap";
import SVG from "react-inlinesvg";
import SnackBarTool from "../../../../_metronic/_partials/widgets/snack-bar/SnackBar";
import { calendarAccess, calendarTest } from "../../../pages/redux/commonCrud";
import { capitalizeFirstLetter } from "../../../utils/canvaCloseFunction";
import { getAddress } from "../../ContactDeals/_redux/contact/contactCrud";
import { WeekCounter, calculateExtraPrice, getInputClasses, isWithinTwoWorkingDaysFromToday, getApiErrorMessage } from "../../../utils/commonFunction";
import moment from "moment";
import { operationCalendar } from "../../Calendar/redux/calendarCrud";
import { toAbsoluteUrl } from "../../../../_metronic/_helpers";
import { useDispatch, useSelector, shallowEqual } from "react-redux";
import { useEffect } from "react";
import { useFormik } from "formik";
import { useIntl } from "react-intl";
import { LensTwoTone } from "@mui/icons-material";
import DateRangeIcon from "@mui/icons-material/DateRange";
import { divideByHundred } from "../../../utils/canvaCloseFunction";
import { convertKilometersToMiles } from "../../../utils/commonFunction";
import { GoogleMap, useJsApiLoader } from "@react-google-maps/api";
import CustomeOrderSaveDialog from "../../../../_metronic/_partials/widgets/alert/CustomeOrderSaveDialog";
import { ReturnWizard } from "../components/ReturnWizard";
import { ecoPlanCo, firstPlanCo, premiumPlanCo } from "../_mocks/dummyData";

/**
 * Modal for booking/editing collection, return, and access dates on an order
 * (and the equivalent flow during new-order creation).
 *
 * @param {string} title - Modal title.
 * @param {string} type - Flow type, e.g. "order" or "new_order".
 * @param {string} keys - Active sub-flow: "collection" | "return" | "access".
 * @param {(key: string) => void} setKeys - Switches the active sub-flow.
 * @param {(open: boolean) => void} setDialog - Toggles this modal.
 * @param {boolean} dialog - Whether the modal is open.
 * @param {Function} dispatchReducer - Dispatches updates to the new-order reducer.
 * @param {Array<object>} depotList - Available depots for selection.
 * @param {string|number} franchise - Franchise id used for calendar lookups.
 * @param {object} state - New-order reducer state.
 * @param {object} value - Existing order/invoice data (order flow).
 * @param {object} initialValues - Initial Formik values.
 * @param {object} orderDetail - The order being edited (order flow).
 * @param {object} paramData - Additional order summary params.
 * @returns {React.ReactElement} The collection/return/access edit modal.
 */
export function CollectionEdit({
  title,
  type,
  keys,
  setKeys,
  setDialog,
  dialog,
  dispatchReducer,
  depotList,
  franchise,
  state,
  value,
  initialValues,
  orderDetail,
  paramData,
}) {
  const dispatch = useDispatch();
  // const { isLoaded } = useJsApiLoader({
  //   id: "google-map-script",
  //   googleMapsApiKey: "AIzaSyCHkQzmrBUQV5Lc2no4PqVOI1AJsz-mNSI",
  // });
  const { cardDetail, extraPrice, returnReasons } = useSelector(
    (state) => ({
      cardDetail: state.order.cardDetail,
      extraPrice: state.order.newFlagData,
      returnReasons: state.order.returnReasons,
    }),
    shallowEqual
  );

  // Reason options for the return wizard's dropdown and its conditional
  // description rule. Fetched once; the list is the same for every order.
  useEffect(() => {
    if (!returnReasons?.length) dispatch(fetchReturnReasons());
  }, []);

  /**
   * Return-wizard schema rebuilt when the reason options change, because
   * which reasons demand a description is decided by the backend.
   */
  const returnWizSchema = useMemo(
    () => getReturnWizSchema(returnReasons),
    [returnReasons]
  );
  const intl = useIntl();
  const [calendarData, setCalendarData] = useState();
  const [activeEvent, setActiveEvent] = useState(null);
  const [actionButton, setActionButton] = useState({ type: "booking" });
  const [loading, setLoading] = useState(false);
  const [snack, setSnack] = useState({ call: false, type: "", message: "" });
  const [dropDown, setDropDown] = useState({ address: [] });
  const [isOverWrite, setIsOverWrite] = useState(false);
  const [dialogSave, setDialogSave] = useState({ type: false, discard: false });
  const [returnData, setReturnData] = useState();
  const [toggleCalendar, setToggleCalendar] = useState(true);
  const [loadingDialog, setLoadingDialog] = useState(false);
  const [returnChecks, setReturnChecks] = useState({
    is_return_cost: 1,
    is_return_congestion_charge: 1,
    is_extra_miles: 1,
    is_storage_cost: 1,
  });
  const [accessAmount, setAccess] = useState(0);

  const handleChargeReturnCalculate = () => {
    // if(orderDetail?.is_container === 2)return;
    formik.setSubmitting(true);
    const queryParams = {
      id: formik?.values?.order_id,
      pod:
        orderDetail?.pod !== formik.values?.return_pod_number?.length &&
        formik.values?.return_pod_number?.length !== 0
          ? formik.values?.return_pod_number?.length
          : orderDetail?.pod,
      type: "return",
      is_student_return: formik?.values?.is_student_return,
      return_date: formik?.values?.return_date,
      return_postcode: formik?.values?.return_postcode
        ? formik?.values?.return_postcode
        : formik?.initialValues?.collection_postcode,
    };
    console.log("checko-2", formik.values);
    setLoadingDialog(true);
    collectionExtraChage(queryParams)
      .then((res) => {
        formik.setSubmitting(false);
        console.log("checko-0", orderDetail?.subscription_data);

        if (
          orderDetail?.subscription_data?.phases &&
          orderDetail?.subscription_data?.phases[0].items.some(
            (e) => e.product_id === import.meta.env.REACT_APP_PRODUCT_FIRST_CLASS
          )
        ) {
          console.log("checko-1");

          const data = {
            franchise_id: orderDetail?.franchise_id || "",
            products:
              orderDetail?.subscription_data?.phases[0].items
                ?.filter(
                  (item) =>
                    item.product_id ===
                    import.meta.env.REACT_APP_PRODUCT_FIRST_CLASS
                )
                ?.map((item) => item.product_id) || [],
            weeks: WeekCounter(
              orderDetail?.collection_date,
              formik?.values?.return_date
            ),
            pod: orderDetail?.pod || "",
            order_id: orderDetail?.id || "",
          };

          if (data.weeks < 14) {
            returnExtraChage(data)
              .then((response) => {
                setReturnData((prevReturnData) => ({
                  ...prevReturnData,
                  ...res.data.data,
                  return_extra_charge: response.data.data,
                }));
                setLoadingDialog(false);
                setDialogSave({ type: false, returnWizard: true });
              })
              .catch((error) => {
                setReturnData((prevReturnData) => ({
                  ...prevReturnData,
                  ...res.data.data,
                }));
                setLoadingDialog(false);
                setDialogSave({ type: false, returnWizard: true });
              });
            console.log("checko-5");
          } else {
            console.log("checko-6");
            if (returnChecks?.is_return_charge) {
              console.log("checko-7");
              setReturnData((prevReturnData) => ({
                ...prevReturnData,
                ...res.data.data,
                return_extra_charge: 0,
              }));
            } else {
              console.log("checko-8");
              setReturnData((prevReturnData) => ({
                ...prevReturnData,
                ...res.data.data,
              }));
            }
            setLoadingDialog(false);
            setDialogSave({ type: false, returnWizard: true });
          }
        } else {
          console.log("checko-9");
          setReturnData((prevReturnData) => ({
            ...prevReturnData,
            ...res.data.data,
          }));
          setLoadingDialog(false);
          setDialogSave({ type: false, returnWizard: true });
        }

        console.log("checko-10");
      })
      .catch((error) => {
        console.log("error", error);

        formik.setSubmitting(false);
        setLoadingDialog(false);
        setSnack({
          call: true,
          type: "error",
          message: getApiErrorMessage(error),
        });
      });
  };
  const handleSubmit = (values, { setSubmitting }) => {
    if (type === "new_order") {
      dispatchReducer({
        type: "deletedProduct",
        value: [],
      });
    }
    setSnack({
      call: false,
      type: "",
      message: "",
    });
    // Without the reason list the wizard cannot tell which reasons need a
    // description, and the server does not check it for this screen.
    if (keys === "return" && dialogSave?.returnWizard && !returnReasons?.length) {
      setSnack({ call: true, type: "error", message: 'The return reasons could not be loaded, so the reason cannot be checked. Use "Try again" under the reason dropdown, then save.' });
      setSubmitting(false);
      return;
    }
    if (type === "order") {
      if (keys === "access") {
        if (!orderDetail?.access_date || orderDetail?.is_access_cancel == 1) {
          if (orderDetail?.order_details?.pod_plan_type === "Economy") {
            values.order_access_charge = accessAmount?.amount;
          }
        }
        if (
          orderDetail?.is_student_access === 1 &&
          orderDetail?.is_access_completed !== 1
        ) {
          values.access_cancel_mail = 1;
        }
        // if (
        //   orderDetail?.access_date &&
        //   orderDetail?.is_student_access == 1 &&
        //   isWithinTwoWorkingDaysFromToday(
        //     orderDetail?.access_date,
        //     new Date(values?.access_date)
        //   ) && orderDetail?.order_details?.pod_plan_type === "Economy"
        // ) {
        //   values.access_refund = accessAmount?.amount;
        // }
        accessUpdate(values, keys)
          .then((res) => {
            formik.setSubmitting(false);
            setSnack({
              call: true,
              type: "success",
              message: res?.data?.message || "",
            });
            dispatch(fetchMyOrderDetailCard(values?.order_id));
            dispatch(fetchMyOrderTimeline(values?.order_id));
            dispatch(fetchPaymentInvoice(values?.order_id));
            setDialog(false);
            setDialogSave({ type: false });
          })
          .catch((error) => {
            setSnack({
              call: true,
              type: "error",
              message: error?.response?.data?.message || "",
            });
            setDialogSave({ type: false });
            formik.setSubmitting(false);
          });
      } else {
        if (
          (keys === "collection" && values?.start_time_slot === "") ||
          (keys === "return" && values?.return_start_time_slot === "")
        ) {
          setSnack({
            call: true,
            type: "error",
            message: "Please Select Time Slot",
          });
          formik.setSubmitting(false);
          return;
        }
        const collectionData = newOrderCollectionValue(
          formik?.values,
          formik,
          "order"
        );
        if (
          formik?.values?.extra_days_charge &&
          formik?.values?.is_student != 1
        ) {
          collectionData.extra_days_charge = formik?.values?.extra_days_charge;
          collectionData.extra_days_type = formik?.values?.extra_days_type;
        }
        let returnDatas = orderReturnValue(formik?.values, formik, "order");
        console.log("returnData", returnData);

        if (
          !returnData?.return_extra_charge &&
          returnData?.pod_price &&
          returnChecks?.is_storage_cost
        ) {
          returnDatas.pod_price = returnData?.pod_price;
          returnDatas.is_pod_price = returnChecks?.is_storage_cost;
        }
        if (
          formik?.values?.return_extra_days_charge &&
          formik?.values?.is_student_return != 1 &&
          returnChecks?.is_extra_days_charge
        ) {
          returnDatas.extra_days_charge =
            formik?.values?.return_extra_days_charge;
          returnDatas.extra_days_type = formik?.values?.return_extra_days_type;
          returnDatas.is_extra_days_charge = returnChecks?.is_extra_days_charge;
        }
        if (
          returnDatas?.return_pod_number &&
          returnDatas?.return_pod_number.length === 0
        ) {
          returnDatas.is_return = 1;
        }
        if (returnData?.toll_charge) {
          returnDatas.toll_charge = returnData?.toll_charge || "";
        }
        console.log("returnDatareturnData", returnData);

        if (
          !returnData?.return_extra_charge &&
          !returnData?.pod_price &&
          returnChecks?.is_pod_charge &&
          (returnData?.extra_days_storage_charge?.plan ||
            returnData?.extra_days_storage_charge?.addon)
        ) {
          returnDatas.is_pod_price = 1;
          returnDatas.pod_db_price = Number(
            sumDayProrated(returnData?.extra_days_storage_charge)
          );
        }
        if (returnData?.depot_return_charge) {
          returnDatas.depot_return_charge =
            returnData?.depot_return_charge || "";
        }
        if (keys === "return" && returnChecks?.is_return_cost) {
          returnDatas.is_return_cost = returnChecks?.is_return_cost;
        }
        if (keys === "return" && returnChecks?.is_return_charge) {
          returnDatas.first_class_charge = returnData?.return_extra_charge;
        }
        if (keys === "return" && returnChecks?.is_return_congestion_charge) {
          returnDatas.is_return_congestion_charge =
            returnChecks?.is_return_congestion_charge;
        }
        if (keys === "return" && returnChecks?.is_extra_miles) {
          returnDatas.is_extra_miles = returnChecks?.is_extra_miles;
        }
        console.log("popo-90", orderDetail);
        if (
          keys === "return" &&
          orderDetail?.subscription_data?.phases?.length &&
          orderDetail?.subscription_data?.phases[0].items
        ) {
          for (let items of orderDetail?.subscription_data?.phases[0].items) {
            if (
              items?.product_id === premiumPlanCo ||
              items?.product_id === ecoPlanCo ||
              items?.product_id === firstPlanCo
            ) {
              returnDatas.price_id = items?.product_id;
            }
          }
        }
        console.log("popo-90", keys, orderDetail);
        if (returnData?.extraMiles?.id) {
          returnDatas.extra_miles_id = returnData?.extraMiles?.id;
          returnDatas.extra_miles_quantity = returnData?.extraMiles?.qty;
          returnDatas.extra_miles_charge = returnData?.extraMiles?.totalPrice;
        }
        if (returnData?.discount) {
          returnDatas.discount_amounts = returnData?.discount;
          returnDatas.apply_on = returnData?.apply_on;
        }
        collectionData.franchise_id = orderDetail?.franchise_id;
        returnDatas.franchise_id = orderDetail?.franchise_id;

        orderDetailUpdate(
          keys === "collection" ? collectionData : returnDatas,
          keys
        )
          .then((res) => {
            dispatch(
              fetchBillingCardDetail(
                orderDetail?.franchise_id,
                orderDetail?.subscription_data?.id,
                setSnack,
                orderDetail?.customer_chargebee_id,
                orderDetail?.id
              )
            );
            formik.setSubmitting(false);
            formik.setFieldValue("return_pod_number", []);
            dispatch(
              fetchPaymentInvoice(
                values?.order_id,
                orderDetail?.franchise_id,
                orderDetail?.subscription_id
              )
            );
            dispatch(
              fetchInvoiceList(
                orderDetail?.franchise_id,
                values?.order_id,
                orderDetail?.subscription_id
              )
            );
            dispatch(fetchMyOrderTimeline(values?.order_id));
            setSnack({
              call: true,
              type: "success",
              message: res?.data?.message || "",
            });
            dispatch(fetchMyOrderDetailCard(values?.order_id));
            dispatch(fetchNewFlags(values?.order_id));
            setDialog(false);
            setDialogSave({ type: false });
            setReturnData();
          })
          .catch((error) => {
            setSnack({
              call: true,
              type: "error",
              message: error?.response?.data?.message || "",
            });
            formik.setSubmitting(false);
            setTimeout(() => {
              setDialogSave({ type: false });
              setReturnData();
            }, 4000);
          });
      }
    } else {
      if (
        (keys === "collection" && values?.start_time_slot === "") ||
        (keys === "return" && values?.return_start_time_slot === "")
      ) {
        setSnack({
          call: true,
          type: "error",
          message: "Please Select Time Slot",
        });
        formik.setSubmitting(false);
        return;
      }
      const collectionData = newOrderCollectionValue(values, formik);
      const returnData = newOrderReturnValue(values, formik);
      // const pod =
      //   (state?.productArray.length > 0 &&
      //     state?.productArray.find((e) => e.type === "plan")?.qty) ||
      //   "";
      // const data = {
      //   collection_date: collectionData?.collection_date || "",
      //   pod: pod,
      //   return_date: returnData?.return_date || "",
      // };
      // const arr = [...paramData.products_id];
      // dispatch(
      //   fetchOrderSummary(
      //     "13",
      //     paramData.unit,
      //     paramData.period,
      //     arr,
      //     cardDetail &&
      //       cardDetail.length > -1 &&
      //       cardDetail[0]?.contact?.franchise_id,
      //     cardDetail && cardDetail.length && cardDetail[0].postcode
      //       ? cardDetail[0].postcode
      //       : "",
      //     "",
      //     "",
      //     "",
      //     "",
      //     data
      //   )
      // );
      formik.setSubmitting(false);
      dispatchReducer({
        type: "collectionRetrun",
        value: keys === "collection" ? collectionData : returnData,
      });
      if (keys === "collection") {
        formik.setValues({
          ...formik.values,
          start_time_slot: "",
          end_time_slot: "",
        });
      } else if (keys === "return") {
        formik.setValues({
          ...formik.values,
          return_start_time_slot: "",
          return_end_time_slot: "",
        });
      }
      const depot = depotList.find(
        (e) => e.depot_id === Number(values?.depot_id)
      );
      if (keys !== "return") {
        dispatchReducer({ type: "depotDataForMap", value: depot });
      }
      setDialog(false);
    }
  };

  const formik = useFormik({
    initialValues: initialValues,
    enableReinitialize: true,
    validationSchema:
      keys === "collection"
        ? CollectionSchema
        : keys === "return" && dialogSave?.returnWizard
        ? returnWizSchema
        : keys === "return"
        ? ReturnSchema
        : false,
    onSubmit: handleSubmit,
  });
  const handleApi = (check, emptyString) => {
    setLoading(true);
    if (check !== "overwrite") {
      setIsOverWrite(false);
    }
    let pod = "";

    if (type === "order" && value) {
      pod = value?.line_items.find((e) => e.type === "plan");
    } else {
      pod = state?.productArray.find((e) => e.type === "plan");
    }
    const query = {
      id: franchise,
      date: selectedDate ? moment(selectedDate).format("yyyy-MM-DD") : "",
      pod: type === "order" ? orderDetail.pod : pod?.qty || 1,
      is_overwrite: check === "overwrite" ? true : false,
    };
    if (cardDetail && cardDetail.length && cardDetail[0].postcode) {
      query.customer_postcode =
        cardDetail && cardDetail.length && cardDetail[0].postcode;
      query.depot_postcode = depotList?.find(
        (e) => e.depot_id == formik?.values?.depot_id
      )?.postcode;
    }
    if (type === "order") {
      query.customer_postcode = orderDetail?.collection_postcode;
      query.depot_postcode = depotList?.find(
        (e) => e.depot_id == (formik?.values?.depot_id || orderDetail?.depot_id)
      )?.postcode;
    }
    if (query.date === "Invalid date" && actionButton?.type === "booking")
      return;
    if (keys === "access") {
      query.is_access = 1;
      query.depot_id = formik?.values?.depot_id;
      if (orderDetail?.order_details?.pod_plan_type === "Economy") {
      }
    }
    if (actionButton?.type === "booking") {
      const calendarFunction =
        type === "order" && keys === "access" ? calendarAccess : calendarTest;
      if (type === "order" && keys === "access") {
        query.day = query?.date
          ? new Date(query.date).getDay() == 0
            ? "7"
            : new Date(query.date).getDay()
          : 1;
      }
      calendarFunction(query)
        .then((res) => {
          setLoading(false);
          setCalendarData(res.data);
          if (check === "overwrite") {
            setDialogSave({ type: false });
          }
        })
        .catch(() => {
          setLoading(false);
        });
    } else {
      operationCalendar(query)
        .then((res) => {
          setLoading(false);
          setCalendarData(res.data);
          if (check === "overwrite") {
            setDialogSave({ type: false });
          }
        })
        .catch(() => {
          setLoading(false);
        });
    }
  };

  useEffect(() => {
    if (franchise && dialog) {
      handleApi();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    franchise,
    formik?.values?.collection_date,
    formik?.values?.return_date,
    formik?.values?.access_date,
    formik?.values?.depot_id,
    value,
    dialog,
    keys,
    actionButton,
    depotList?.length,
  ]);
  const handleCheck = (e) => {
    if (e.target.checked) {
      keys === "collection"
        ? formik.setValues({
            ...formik?.values,
            is_collection_address: "0",
            collection_postcode: formik?.initialValues?.collection_postcode,
            collection_address_line:
              formik?.initialValues?.collection_address_line,
            collection_address_city:
              formik?.initialValues?.collection_address_city,
          })
        : formik.setValues({
            ...formik?.values,
            is_return_address: "0",
            return_postcode: formik?.initialValues?.collection_postcode,
            return_address_line: formik?.initialValues?.collection_address_line,
            return_address_city: formik?.initialValues?.collection_address_city,
          });
    } else {
      formik.setErrors({});
      formik.resetForm();
      setDropDown({ ...dropDown, address: [] });
      keys === "collection"
        ? formik.setValues({
            ...formik.values,
            is_collection_address: 1,
            collection_postcode: "",
            collection_address_line: "",
            collection_address_city: "",
          })
        : formik.setValues({
            ...formik.values,
            is_return_address: 1,
            return_postcode: "",
            return_address_line: "",
            return_address_city: "",
          });
    }
  };
  const myRef = useRef(null);

  const handleManualUpdate = () => {
    formik.setFieldValue("is_return_address_manual", 1);
    formik.setFieldValue("return_address_line", "");
  };

  const handleGetAddress = async (postcode) => {
    if (!postcode) return;
    formik.setFieldValue(
      keys === "collection" ? "is_address_manual" : "is_return_address_manual",
      "0"
    );

    getAddress(postcode)
      .then((res) => {
        setDropDown({ address: res.data.addresses });
        formik.setFieldValue(
          keys === "return" ? "return_address_city" : "collection_address_city",
          res.data.addresses[0].town_or_city
        );
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: "Cannot find Post Code",
        });
      });
  };
  useEffect(() => {
    if (
      formik?.values?.collection_postcode ||
      formik?.values?.return_postcode
    ) {
      handleGetAddress(
        keys === "return"
          ? formik?.values?.return_postcode
          : formik?.values?.collection_postcode
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    keys,
    formik?.values?.is_collection_address,
    formik?.values?.is_return_address,
  ]);

  useEffect(() => {
    if (Object.entries(formik.errors).length > 0 && formik.isSubmitting) {
      if (Object.entries(formik.errors).length > 0) {
        const [key, value] = Object.entries(formik.errors)[0];

        setSnack({
          call: true,
          type: "error",
          message: value,
        });
        return;
      }
    }
  }, [formik.errors, formik.isSubmitting]);
  useEffect(() => {
    if (snack.call) {
      setTimeout(() => {
        setSnack({
          call: false,
          type: "",
          message: "",
        });
      }, 2000);
    }
  }, [snack.call]);

  // handleClose is called when the form is closed
  const handleClose = () => {
    if (type === "new_order") {
      if (keys === "collection") {
        formik.setValues({
          ...formik.values,
          start_time_slot: "",
          end_time_slot: "",
        });
      } else if (keys === "return") {
        formik.setValues({
          ...formik.values,
          return_start_time_slot: "",
          return_end_time_slot: "",
        });
      }
      const collectionData = newOrderCollectionValue(formik?.values, formik);
      const returnData = newOrderReturnValue(formik?.values, formik);
      if (
        (keys === "collection" && state?.collectionRetrun?.start_time_slot) ||
        (keys === "return" && state?.collectionRetrun?.return_start_time_slot)
      ) {
        dispatchReducer({
          type: "collectionRetrun",
          value: keys === "collection" ? collectionData : returnData,
        });
      }
    }
    if (formik.dirty || Object.keys(formik.touched).length !== 0) {
      setDialogSave({ ...dialogSave, discard: true });
    } else {
      setDialog(false);
    }

    setToggleCalendar(true);
  };
  const handleCancel = () => {
    setSnack({
      call: false,
      type: "",
      message: "",
    });
    const data = {
      order_id: formik?.values?.order_id,
      booking_type: capitalizeFirstLetter(keys),
    };
    cancelReturnAccess(data)
      .then((res) => {
        setDialog(false);
        setDialogSave({ type: false });
        setSnack({
          call: true,
          type: "success",
          message: res?.data?.message || "",
        });
        dispatch(fetchMyOrderTimeline(orderDetail?.id));
        dispatch(fetchMyOrderDetailCard(orderDetail?.id));
      })
      .catch((error) => {
        setSnack({
          call: true,
          type: "error",
          message: error?.response?.data?.message,
        });
      });
  };

  const filterDisabledDays = (date) => {
    const dayOfWeek = date.getDay();
    const dayOfWeekString = [
      "sunday",
      "monday",
      "tuesday",
      "wednesday",
      "thursday",
      "friday",
      "saturday",
    ][dayOfWeek];
    let show = true;
    if (calendarData?.data?.franchise_working_days) {
      show = calendarData?.data?.franchise_working_days[dayOfWeekString] === 1;
    }
    return show;
  };
  const handleSetCheck = (e, id, number) => {
    const fieldName =
      keys === "return" ? "return_pod_number" : "access_pod_number";
    let arr = [...formik.values[fieldName]];

    if (e.target.checked) {
      arr.push(id);
    } else {
      const index = arr.indexOf(id);
      if (index !== -1) {
        arr.splice(index, 1);
      }
    }

    formik.setFieldValue(fieldName, arr);
    const filterData = orderDetail?.pod_storage_details?.filter(
      (item) =>
        item.is_return === 0 &&
        item?.is_remove_by_driver === 0 &&
        item?.is_initial != 2
    );

    if (
      filterData.length !== arr.length &&
      arr.length > 0 &&
      keys === "return"
    ) {
      formik.setFieldValue("is_return", "0");
    } else if (filterData.length === arr.length) {
      formik.setFieldValue("is_return", "1");
    }
  };

  const selectedDate = useMemo(() => {
    switch (keys) {
      case "collection":
        return formik?.values?.collection_date || "";
      case "return":
        return formik?.values?.return_date || "";
      case "access":
        return formik?.values?.access_date || "";
      default:
        return "";
    }
  }, [formik?.values, keys]);
  /**
   * Calculates extra-miles charges by fetching directions between collection and return addresses,
   * then updates returnData state with the computed extra miles pricing (non-Stripe variant).
   * @returns {Promise<void>}
   */
  const handleResponse = async () => {
    if (formik?.values?.is_student_return === 1) return;

    const value = formik.values;
    const origin = value?.collection_address_line + "," + value?.collection_address_city + "," + value?.collection_postcode;
    const destination = value?.return_address_line + "," + value?.return_address_city + "," + value?.return_postcode;

    try {
      const dirResponse = await axios.get(
        `${import.meta.env.REACT_APP_SITE_URL}directions`,
        {
          params: { origin, destination },
          headers: {
            Authorization: `Bearer ${localStorage.getItem("authToken")}`,
          },
        }
      );

      if (dirResponse.data?.success && dirResponse.data?.data) {
        const dirData = dirResponse.data.data;
        const res = await extraMiles(franchise);
        const response = res.data.data;
        const price = response?.product_prices[0]?.unit_amount;

        let miles = (dirData.distance_miles - 10) || "-";
        let actualMiles = +miles > 0 ? +miles : 0;
        let Totalprice = calculateExtraPrice(
          Math.round(actualMiles),
          price
        );
        let check = extraPrice?.extra_miles_charge;
        let amount = check ? Totalprice - check : 0;
        let FinalAmount = amount > 0 ? amount : 0;
        let podNumber = Number(orderDetail?.pod);
        let count = 1;

        if (podNumber) {
          const thresholds = [4, 7, 10, 13, 16, 19, 22, 25, 28, 31];
          for (let i = 0; i < thresholds.length; i++) {
            if (podNumber >= thresholds[i]) {
              count = i + 2;
            } else {
              break;
            }
          }
        }

        setReturnData((prevReturnData) => ({
          ...prevReturnData,
          extraMiles: {
            id: response.stripe_product_id,
            totalPrice: check
              ? +FinalAmount * +count
              : orderDetail?.booking_reference === "254-060223-47721"
              ? "60"
              : +Totalprice * +count,
            qty: Math.round(miles),
          },
        }));
      } else {
        console.error("Error fetching directions from API");
      }
    } catch (error) {
      console.error("Error fetching directions:", error);
    }
  };

  useEffect(() => {
    const hideSnack = () => {
      setSnack({
        call: false,
        type: "",
        message: "",
      });
    };

    const timeoutId = setTimeout(hideSnack, 6000);

    return () => clearTimeout(timeoutId);
  }, []);

  const sumDayProrated = (data) => {
    let totalDayProrated = 0;

    for (const key in data) {
      if (data[key].day_prorated) {
        totalDayProrated += parseFloat(data[key].day_prorated);
      }
    }

    return totalDayProrated;
  };
  return (
    <>
      <Modal
        show={dialog}
        onHide={() => handleClose()}
        aria-labelledby="example-modal-sizes-title-lg"
        size="lg"
        dialogClassName="my-modal60"
        contentClassName="modal-height"
      >
        <Modal.Header closeButton>
          <Modal.Title>{capitalizeFirstLetter(keys) + " Date"}</Modal.Title>
          {keys === "return" ? (
            <span style={{ color: "darkred" }}>
              You no longer have to create ad-hoc charge as vault will
              automatically do that.
            </span>
          ) : (
            ""
          )}
          <div style={{ position: "absolute", top: "15px", right: "10px" }}>
            <span
              className="btn btn-xs btn-icon btn-light btn-hover-primary"
              onClick={() => handleClose()}
            >
              <i className="ki ki-close icon-sm text-muted"></i>
            </span>
          </div>
        </Modal.Header>

        {/*end::Header*/}
        <Modal.Body className="calendarModal">
          {loading && <LoadingCustome />}
          <form onSubmit={formik.handleSubmit}>
            {dialogSave?.returnWizard && keys === "return" ? (
              <div>
                <ReturnWizard
                  setDialogSave={setDialogSave}
                  sumDayProrated={sumDayProrated}
                  extraData={
                    keys === "return" &&
                    // &&
                    // (formik?.values?.return_pod_number?.length === 0 ||
                    //   formik?.values?.return_pod_number?.length ===
                    //   +orderDetail?.pod)
                    dialogSave?.check !== "overwrite"
                  }
                  formik={formik}
                  returnData={returnData}
                  setReturnData={setReturnData}
                  loadingDialog={loadingDialog}
                  orderDetail={orderDetail}
                  setReturnChecks={setReturnChecks}
                  returnChecks={returnChecks}
                />
              </div>
            ) : (
              <div className=" px-10 ">
                {type !== "order" ? (
                  <>
                    <button
                      type="button"
                      className={`btn ${
                        keys === "collection" ? "btn-primaryCus" : "btn-dark"
                      } font-weight-bolder font-size-sm mr-3 `}
                      onClick={() => setKeys("collection")}
                    >
                      {intl.formatMessage({ id: "Collection" })}
                    </button>
                    <button
                      type="button"
                      className={`btn ${
                        keys === "return" ? "btn-primaryCus" : "btn-dark"
                      } font-weight-bolder font-size-sm mr-3 `}
                      onClick={() => setKeys("return")}
                      disabled={
                        !state?.collectionRetrun?.collection_date &&
                        type === "new_order"
                      }
                    >
                      {intl.formatMessage({ id: "Return" })}
                    </button>

                    {type !== "new_order" && (
                      <button
                        type="button"
                        className={`btn ${
                          keys === "access" ? "btn-primaryCus" : "btn-dark"
                        } font-weight-bolder font-size-sm mr-3 `}
                        onClick={() => setKeys("access")}
                        disabled={orderDetail?.is_collection_completed !== 1}
                      >
                        {intl.formatMessage({ id: "Access" })}
                      </button>
                    )}
                  </>
                ) : (
                  ""
                )}
                <button
                  type="button"
                  className={`btn  ${
                    toggleCalendar === true ? "btn-primaryCus" : "btn-dark"
                  }  font-weight-bolder font-size-sm mr-3 `}
                  onClick={(e) => setToggleCalendar(!toggleCalendar)}
                >
                  <DateRangeIcon />
                </button>

                {toggleCalendar ? (
                  <div className="row">
                    <div className=" col-xxl-5 col-xl-6 col-sm-12 mt-2">
                      <div className="row">
                        <div className="col-sm-12 collection-date">
                          <DatePicker
                            className="form-control"
                            dateFormat="dd-MM-Y"
                            excludeDates={[
                              new Date(
                                state?.collectionRetrun?.collection_date ||
                                  formik?.values?.collection_date
                              ),
                            ]}
                            selected={
                              selectedDate ? Date.parse(selectedDate) : ""
                            }
                            onChange={(date) => {
                              if (keys === "collection") {
                                formik.setFieldValue("start_time_slot", "");
                              } else if (keys === "return") {
                                formik.setFieldValue(
                                  "return_start_time_slot",
                                  ""
                                );
                              }
                              formik.setFieldValue(
                                keys === "collection"
                                  ? "collection_date"
                                  : keys === "return"
                                  ? "return_date"
                                  : keys === "access"
                                  ? "access_date"
                                  : "",
                                moment(date).format("yyyy-MM-DD")
                              );
                            }}
                            placeholderText="Select Collection Date"
                            inline
                            minDate={
                              keys === "return" || keys === "access"
                                ? Date.parse(
                                    type === "order"
                                      ? formik?.values?.collection_date
                                      : state?.collectionRetrun?.collection_date
                                  )
                                : new Date()
                              // moment()
                              //     .add(1, "days")
                              //     .toDate()
                            }
                            maxDate={
                              keys === "collection" &&
                              formik?.values?.return_date
                                ? Date.parse(
                                    moment(
                                      formik?.values?.return_date
                                    ).subtract(1, "days")
                                  )
                                : false
                            }
                            filterDate={filterDisabledDays}
                          />
                        </div>
                      </div>
                    </div>

                    <div className="col-md-6 col-sm-12">
                      <div className="mt-2 mb-2">
                        {/* {type}
                    <div>
                      <span>
                        Note* please complete Access first
                        </span>
                    </div> */}
                        {keys === "return" ? (
                          <span>
                            {intl.formatMessage({ id: "Date.selected" })}:{" "}
                            {formik?.values?.return_date
                              ? moment(formik?.values?.return_date).format(
                                  "DD-MM-YYYY"
                                )
                              : ""}
                            {formik?.values?.return_start_time_slot
                              ? "- " + formik?.values?.return_start_time_slot
                              : ""}
                            {formik?.values?.return_start_time_slot &&
                              formik?.values?.return_end_time_slot &&
                              formik?.values?.return_start_time_slot !==
                                moment(
                                  formik?.values?.return_date +
                                    "T" +
                                    formik?.values?.return_end_time_slot
                                )
                                  .subtract(1, "hours")
                                  .format("HH:mm") &&
                              "-" +
                                moment(
                                  formik?.values?.return_date +
                                    "T" +
                                    formik?.values?.return_end_time_slot
                                )
                                  .subtract(1, "hours")
                                  .format("HH:mm")}
                          </span>
                        ) : keys === "access" ? (
                          <span>
                            {intl.formatMessage({ id: "Date.selected" })}:{" "}
                            {formik?.values?.access_date
                              ? moment(formik?.values?.access_date).format(
                                  "DD-MM-YYYY"
                                )
                              : ""}{" "}
                            {formik?.values?.access_start_time_slot
                              ? " - " + formik?.values?.access_start_time_slot
                              : ""}
                          </span>
                        ) : (
                          <span>
                            {intl.formatMessage({ id: "Date.selected" })}:{" "}
                            {formik?.values?.collection_date
                              ? moment(formik?.values?.collection_date).format(
                                  "DD-MM-YYYY"
                                )
                              : ""}
                            {formik?.values?.start_time_slot
                              ? "- " + formik?.values?.start_time_slot
                              : ""}
                            {formik?.values?.end_time_slot &&
                              formik?.values?.start_time_slot &&
                              formik?.values?.start_time_slot !==
                                moment(
                                  formik?.values?.collection_date +
                                    "T" +
                                    formik?.values?.end_time_slot
                                )
                                  .subtract(1, "hours")
                                  .format("HH:mm") &&
                              " - " +
                                moment(
                                  formik?.values?.collection_date +
                                    "T" +
                                    formik?.values?.end_time_slot
                                )
                                  .subtract(1, "hours")
                                  .format("HH:mm")}
                          </span>
                        )}
                      </div>
                      {keys !== "return" && (
                        <div className=" collection-form mt-2 ">
                          <div className="form-inline mb-5">
                            <span className="mr-2 ">
                              {" "}
                              {intl.formatMessage({ id: "Depot.Request" })}
                            </span>{" "}
                            <FormControl fullWidth>
                              <Select
                                MenuProps={{
                                  anchorOrigin: {
                                    vertical: "bottom",
                                    horizontal: "left",
                                  },
                                  transformOrigin: {
                                    vertical: "top",
                                    horizontal: "left",
                                  },
                                  getContentAnchorEl: null,
                                }}
                                className="form-control w-100 "
                                IconComponent={(props) => (
                                  <i {...props}>
                                    <KeyboardArrowDownIcon />
                                  </i>
                                )}
                                inputProps={{ "aria-label": "Without label" }}
                                displayEmpty
                                disabled={keys === "access"}
                                {...formik.getFieldProps("depot_id")}
                              >
                                <MenuItem value="">
                                  {intl.formatMessage({ id: "Depot" })}
                                </MenuItem>
                                {depotList && depotList.length > 0
                                  ? depotList.map((item, index) => {
                                      if (item?.status !== 1) return;
                                      return (
                                        <MenuItem
                                          value={item?.depot_id}
                                          key={index}
                                        >
                                          {item?.name || ""}(Dis-{" "}
                                          {
                                            item?.distance_from_postcode
                                              ?.distance
                                          }{" "}
                                          {
                                            item?.distance_from_postcode
                                              ?.duration
                                          }
                                          )
                                        </MenuItem>
                                      );
                                    })
                                  : null}
                              </Select>
                              {formik.touched.depot_id &&
                              formik.errors.depot_id ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block" ref={myRef}>
                                    {formik.errors.depot_id}
                                  </div>
                                </div>
                              ) : null}
                            </FormControl>
                            <br />
                          </div>
                        </div>
                      )}

                      {keys === "access" ||
                      (keys === "return" &&
                        orderDetail?.is_return !== 1 &&
                        orderDetail?.is_collection_completed === 1 &&
                        Number(orderDetail?.pod) !== 1) ? (
                        <div className="col-xxl-5 col-md-8 mb-2 loader-dropdown d-flex ">
                          <label className="mt-2">
                            Select&nbsp;Pods:&nbsp;&nbsp;
                          </label>
                          <Dropdown
                            className="dropdown-inline"
                            drop="down"
                            alignRight
                          >
                            <Dropdown.Toggle
                              id="dropdown-toggle-top2"
                              variant="transparent"
                              className="btn btn-light   dropdown-toggle text-dark-75"
                              title={
                                <span>
                                  <i className="fad fa-newspaper"></i> Dropdown
                                </span>
                              }
                            >
                              Select pod
                            </Dropdown.Toggle>
                            <Dropdown.Menu className="dropdown-menu dropdown-menu-sm dropdown-menu-right">
                              <ul className="navi navi-hover">
                                {orderDetail?.pod_storage_details?.map(
                                  (item, index) => {
                                    if (
                                      (keys === "return" &&
                                        item?.is_return === 1) ||
                                      (keys === "return" &&
                                        item?.is_remove_by_driver === 1) ||
                                      (keys === "access" &&
                                        item?.is_initial == 2) ||
                                      (keys === "return" &&
                                        item?.is_initial == 2)
                                    )
                                      return;
                                    else {
                                      return (
                                        <li className="navi-item palav">
                                          <>
                                            <span className="navi-text">
                                              <label class="checkbox">
                                                <input
                                                  type="checkbox"
                                                  data-keys={
                                                    orderDetail?.is_return
                                                  }
                                                  // name={`loader_id[${index}]`}
                                                  checked={
                                                    keys === "return"
                                                      ? formik?.values
                                                          ?.return_pod_number &&
                                                        formik?.values
                                                          ?.return_pod_number
                                                          .length &&
                                                        formik?.values?.return_pod_number.some(
                                                          (e) => e === item?.id
                                                        )
                                                      : keys === "access"
                                                      ? formik?.values
                                                          ?.access_pod_number &&
                                                        formik?.values
                                                          ?.access_pod_number
                                                          .length &&
                                                        formik?.values?.access_pod_number.some(
                                                          (e) => e === item?.id
                                                        )
                                                      : ""
                                                  }
                                                  disabled={
                                                    keys === "return" &&
                                                    (Number(
                                                      orderDetail?.pod
                                                    ) === 1 ||
                                                      Number(
                                                        orderDetail?.is_return
                                                      ) === 1 ||
                                                      (item?.is_return === 1 &&
                                                        item?.is_remove_by_driver !==
                                                          0))
                                                  }
                                                  onChange={(e) => {
                                                    if (
                                                      orderDetail?.is_return !==
                                                        1 &&
                                                      orderDetail.partial_return &&
                                                      orderDetail.partial_return
                                                        .length &&
                                                      keys === "return" &&
                                                      orderDetail.partial_return.some(
                                                        (e) =>
                                                          e.is_partial_return_completed !==
                                                          1
                                                      )
                                                    ) {
                                                      setSnack({
                                                        call: true,
                                                        type: "error",
                                                        message:
                                                          "Please complete the existing partial return before booking the next one.",
                                                      });
                                                      return;
                                                    }
                                                    handleSetCheck(
                                                      e,
                                                      item?.id,
                                                      item?.pod_number
                                                    );
                                                  }}
                                                />
                                                <span className="mr-2"></span>{" "}
                                                {item?.pod_number || "N/A"}
                                              </label>
                                            </span>
                                          </>
                                        </li>
                                      );
                                    }
                                  }
                                ) || ""}
                              </ul>
                            </Dropdown.Menu>
                          </Dropdown>
                        </div>
                      ) : (
                        ""
                      )}
                      {keys === "return" && (
                        <>
                          {["radio"].map((type) => (
                            <div
                              key={`custom-${type}`}
                              className=" checkbox mb-3"
                            >
                              <Form.Check
                                className="mb-2"
                                custom
                                name="Checkboxes4"
                                checked={
                                  keys === "collection" &&
                                  formik?.values?.is_collection_address === "0"
                                    ? true
                                    : keys === "return" &&
                                      formik?.values?.is_return_address === "0"
                                    ? true
                                    : false
                                }
                                type="checkbox"
                                id={`custom-${type}`}
                                label={`${capitalizeFirstLetter(
                                  keys
                                )} address same as ${
                                  keys === "collection"
                                    ? "Customer"
                                    : "Collection"
                                } address`}
                                onClick={handleCheck}
                              />
                            </div>
                          ))}
                        </>
                      )}
                      {((keys === "collection" &&
                        formik?.values?.is_collection_address === 1) ||
                        (keys === "return" &&
                          formik?.values?.is_return_address === 1)) && (
                        <div className="row">
                          <div className="col-12">
                            <label>
                              {intl.formatMessage({ id: "Post.Code" })}
                            </label>
                            <div className="row align-items-center">
                              <div className="col-6 d-flex justify-content-between align-items-center ">
                                <div className="form-groupB w-100">
                                  <input
                                    type="text"
                                    className={`form-control  ${getInputClasses(
                                      formik,
                                      keys === "return"
                                        ? "return_postcode"
                                        : "collection_postcode"
                                    )}`}
                                    placeholder={intl.formatMessage({
                                      id: "Post.Code",
                                    })}
                                    name={
                                      keys === "return"
                                        ? "return_postcode"
                                        : "collection_postcode"
                                    }
                                    {...formik.getFieldProps(
                                      keys === "return"
                                        ? "return_postcode"
                                        : "collection_postcode"
                                    )}
                                  />
                                </div>
                                <div className="mb-2">
                                  <span className="symbol-label ml-2">
                                    <span
                                      className="svg-icon svg-icon-lg svg-icon-primary"
                                      onClick={() =>
                                        handleGetAddress(
                                          keys === "return"
                                            ? formik.values.return_postcode
                                            : formik.values.collection_postcode
                                        )
                                      }
                                    >
                                      <SVG
                                        className="h-25 align-self-end"
                                        style={{ cursor: "pointer" }}
                                        title=" "
                                        src={toAbsoluteUrl(
                                          "/media/svg/icons/General/Search.svg"
                                        )}
                                      ></SVG>
                                    </span>
                                  </span>
                                </div>
                              </div>
                              <div className="col-md-6 mb-2 ">
                                <span
                                  style={{
                                    color: "#ff9f60",
                                    cursor: "pointer",
                                  }}
                                  onClick={handleManualUpdate}
                                >
                                  {intl.formatMessage({ id: "Enter.Manually" })}
                                </span>
                              </div>
                              {formik.touched.collection_postcode &&
                              keys === "collection" &&
                              formik.errors.collection_postcode ? (
                                <div className=" ml-4 mb-4 fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {formik?.errors?.collection_postcode}
                                  </div>
                                </div>
                              ) : null}
                              {formik.touched.return_postcode &&
                              keys === "return" &&
                              formik.errors.return_postcode ? (
                                <div className=" ml-4 mb-4 fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {formik?.errors?.return_postcode}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-12">
                            <label>
                              {intl.formatMessage({ id: "Address" })}
                            </label>
                            <div className="form-groupB">
                              {formik.values.is_return_address_manual === 1 ? (
                                <input
                                  type="text"
                                  className={`form-control  ${getInputClasses(
                                    formik,
                                    "address"
                                  )}`}
                                  placeholder={intl.formatMessage({
                                    id: "Address",
                                  })}
                                  name={
                                    keys === "return"
                                      ? "return_address_line"
                                      : "collection_address_line"
                                  }
                                  {...formik.getFieldProps(
                                    keys === "return"
                                      ? "return_address_line"
                                      : "collection_address_line"
                                  )}
                                />
                              ) : (
                                <FormControl fullWidth>
                                  <Select
                                    name={
                                      keys === "return"
                                        ? "return_address_line"
                                        : "collection_address_line"
                                    }
                                    MenuProps={{
                                      anchorOrigin: {
                                        vertical: "bottom",
                                        horizontal: "left",
                                      },
                                      transformOrigin: {
                                        vertical: "top",
                                        horizontal: "left",
                                      },
                                      getContentAnchorEl: null,
                                    }}
                                    className={`form-control  ${getInputClasses(
                                      formik,
                                      keys === "return"
                                        ? "return_address_line"
                                        : "collection_address_line"
                                    )}`}
                                    IconComponent={(props) => (
                                      <i {...props}>
                                        <KeyboardArrowDownIcon />
                                      </i>
                                    )}
                                    inputProps={{
                                      "aria-label": "Without label",
                                    }}
                                    displayEmpty
                                    {...formik.getFieldProps(
                                      keys === "return"
                                        ? "return_address_line"
                                        : "collection_address_line"
                                    )}
                                  >
                                    <MenuItem value="">
                                      {intl.formatMessage({ id: "Address" })}
                                    </MenuItem>
                                    {dropDown?.address &&
                                    dropDown?.address.length > 0
                                      ? dropDown?.address.map((data, index) => {
                                          // const addressData = data.formatted_address.toString();
                                          let addressData = data.formatted_address.toString();
                                          addressData = addressData?.replaceAll(
                                            ", ",
                                            ","
                                          );
                                          addressData = addressData?.replaceAll(
                                            ",, ",
                                            ","
                                          );
                                          addressData = addressData?.replaceAll(
                                            ",,,",
                                            ","
                                          );
                                          return (
                                            <MenuItem
                                              value={addressData}
                                              key={index}
                                            >
                                              {addressData}
                                            </MenuItem>
                                          );
                                        })
                                      : null}
                                  </Select>
                                </FormControl>
                              )}

                              {formik.touched.collection_address_line &&
                              keys === "collection" &&
                              formik.errors.collection_address_line ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {formik.errors.collection_address_line}
                                  </div>
                                </div>
                              ) : null}
                              {formik.touched.return_address_line &&
                              keys === "return" &&
                              formik.errors.return_address_line ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {formik.errors.return_address_line}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                          <div className="col-12">
                            <label>{intl.formatMessage({ id: "CITY" })}</label>
                            <div className="form-groupB">
                              <input
                                type="text"
                                className={`form-control  ${getInputClasses(
                                  formik,
                                  keys === "return"
                                    ? "return_address_city"
                                    : "collection_address_city"
                                )}`}
                                placeholder="City"
                                name="city"
                                {...formik.getFieldProps(
                                  keys === "return"
                                    ? "return_address_city"
                                    : "collection_address_city"
                                )}
                              />
                              {formik.touched.collection_address_city &&
                              keys === "collection" &&
                              formik.errors.collection_address_city ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {formik.errors.collection_address_city}
                                  </div>
                                </div>
                              ) : null}
                              {formik.touched.return_address_city &&
                              keys === "return" &&
                              formik.errors.return_address_city ? (
                                <div className="fv-plugins-message-container">
                                  <div className="fv-help-block">
                                    {formik.errors.return_address_city}
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                ) : (
                  ""
                )}
                <div className="mt-4 mb-4">
                  <div
                    className="mb-4 d-flex "
                    style={{ justifyContent: "space-between" }}
                  >
                    <div>
                      <button
                        className={`btn ${
                          actionButton.type === "booking"
                            ? "btn-primaryCus"
                            : "btn-dark"
                        } font-weight-bolder font-size-sm mr-3 `}
                        onClick={() =>
                          setActionButton({ ...actionButton, type: "booking" })
                        }
                        type="button"
                      >
                        {intl.formatMessage({ id: "Booking" })}
                      </button>
                      {/* <button
                      className={`btn ${
                        actionButton.type === "operation"
                          ? "btn-primaryCus"
                          : "btn-dark"
                      } font-weight-bolder font-size-sm mr-3 `}
                      type="button"
                      onClick={() =>
                        setActionButton({ ...actionButton, type: "operation" })
                      }
                    >
                      {intl.formatMessage({ id: "Operation" })}
                    </button> */}
                    </div>
                    {actionButton?.type !== "operation" && keys !== "access" && (
                      <div>
                        <button
                          className={`btn ${
                            isOverWrite ? "btn-primaryCus" : "btn-dark"
                          } font-weight-bolder font-size-sm mr-3 `}
                          onClick={() => {
                            // setIsOverWrite(true);
                            setDialogSave({ type: true, check: "overwrite" });
                          }}
                          type="button"
                        >
                          {intl.formatMessage({ id: "Overwrite" })}
                        </button>
                      </div>
                    )}
                  </div>
                  {keys !== "access" && (
                    <CalendarComponent
                      collectionDate={Date.parse(
                        keys === "collection"
                          ? formik?.values?.collection_date
                          : keys === "return"
                          ? formik?.values?.return_date
                          : moment().toDate()
                      )}
                      calendarData={calendarData}
                      formik={formik}
                      keys={keys}
                      activeEvent={activeEvent}
                      setActiveEvent={setActiveEvent}
                      actionButton={actionButton}
                      isOverWrite={isOverWrite}
                    />
                  )}
                  <DropOff
                    collectionDate={Date.parse(
                      keys === "collection"
                        ? formik?.values?.collection_date
                        : keys === "return"
                        ? formik?.values?.return_date
                        : keys === "access"
                        ? formik?.values?.access_date
                        : new Date()
                    )}
                    calendarData={calendarData}
                    formik={formik}
                    keys={keys}
                    activeEvent={activeEvent}
                    setActiveEvent={setActiveEvent}
                    actionButton={actionButton}
                    type={type}
                    state={state}
                    orderDetail={orderDetail}
                    depotList={depotList}
                  />
                </div>
              </div>
            )}
            <Modal.Footer>
              <div
                className={`${
                  dialogSave?.returnWizard ? "w-100 ml-4" : ""
                } d-flex justify-content-between`}
              >
                {dialogSave?.returnWizard && (
                  <button
                    type="button"
                    className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
                    onClick={() => {
                      setDialogSave({ type: false, returnWizard: false });
                      setReturnData();
                      // setDialog(false)
                    }}
                  >
                    Back
                  </button>
                )}
                <div className="d-flex">
                  <button
                    type="button"
                    className="btn btn-dark font-weight-bolder font-size-sm mr-3 "
                    onClick={() => {
                      handleClose();
                      // setDialog(false)
                    }}
                  >
                    {intl.formatMessage({ id: "CANCEL" })}
                  </button>
                  <button
                    type={type === "order" ? "button" : "submit"}
                    className="btn btn-primary font-weight-bolder font-size-sm "
                    disabled={
                      (!formik.dirty &&
                        Object.keys(formik.touched).length === 0) ||
                      formik?.isSubmitting
                    }
                    onClick={() => {
                      if (type !== "order") return;
                      if (Object.entries(formik.errors).length > 0) {
                        const [key, value] = Object.entries(formik.errors)[0];

                        setSnack({
                          call: true,
                          type: "error",
                          message: value,
                        });
                        return;
                      }
                      // if (
                      //   keys === "return" &&
                      //   !dialogSave?.returnWizard &&
                      //   orderDetail?.is_container !== 2
                      // ) {
                      //   console.log("popo-1");

                      //   setReturnChecks({
                      //     is_return_cost: 1,
                      //     is_return_congestion_charge: 1,
                      //     is_extra_miles: 1,
                      //     is_return_charge: 1
                      //   });
                      // }
                      if (
                        keys === "return" &&
                        orderDetail?.is_container === 2
                      ) {
                        console.log("popo-2");

                        setReturnChecks({
                          is_return_cost: "0",
                          is_return_congestion_charge: "1",
                          is_extra_miles: "0",
                          is_return_charge: "0",
                        });
                      }

                      if (
                        keys === "return" &&
                        !dialogSave?.returnWizard
                        // &&
                        // (formik?.values?.return_pod_number?.length === 0 ||
                        //   formik?.values?.return_pod_number?.length ===
                        //   +orderDetail?.pod)
                      ) {
                        console.log("popo-3");

                        setReturnChecks({
                          is_return_cost: 1,
                          is_return_congestion_charge: 1,
                          is_extra_miles: 1,
                          is_return_charge: 1,
                          is_pod_charge: 1,
                          is_storage_cost: 1,
                          is_extra_days_charge: 1,
                        });
                        handleResponse();
                        handleChargeReturnCalculate();
                        // setDialogSave({ type: false, returnWizard: true });
                        return;
                      }

                      if (
                        keys === "return" &&
                        dialogSave?.returnWizard &&
                        (formik?.values?.return_pod_number?.length === 0 ||
                          formik?.values?.return_pod_number?.length ===
                            +orderDetail?.pod)
                      ) {
                        console.log("popo-4");

                        setDialogSave({ type: true, returnWizard: true });
                        return;
                      }
                      setDialogSave({ type: true });
                    }}
                  >
                    {intl.formatMessage({ id: "SAVE" })}{" "}
                    {formik?.isSubmitting && (
                      <span className="ml-2 mr-2 spinner spinner-white"></span>
                    )}
                  </button>
                </div>
              </div>
            </Modal.Footer>

            <CustomeOrderSaveDialog
              header={
                dialogSave?.check === "overwrite"
                  ? intl.formatMessage({ id: "Overwrite.Maximum.Time.Slot" })
                  : dialogSave?.cancel
                  ? intl.formatMessage({ id: "Cancel.job" })
                  : keys === "access" && orderDetail?.is_student_access === 1
                  ? intl.formatMessage({ id: "Change.Access" })
                  : keys === "access" && orderDetail?.is_student_access === 0
                  ? "Book Access?"
                  : intl.formatMessage({ id: "Save.Changes" })
              }
              mainText={
                dialogSave?.check === "overwrite"
                  ? intl.formatMessage({ id: "Have.overwrite.time.slot" })
                  : dialogSave?.cancel
                  ? intl.formatMessage({ id: "Are.you.cancel.booking" })
                  : keys === "access" && orderDetail?.is_student_access === 1
                  ? "Are you sure you want to change this access request?"
                  : keys === "access" && orderDetail?.is_student_access === 0
                  ? "Are you sure you want to book this access request?"
                  : intl.formatMessage({ id: "Do.you.changes.booking" })
              }
              dialog={dialogSave}
              setDialog={setDialogSave}
              type={dialogSave?.check === "overwrite" ? "overwrite" : "order"}
              formik={formik}
              handleAction={dialogSave?.cancel ? handleCancel : handleApi}
              // extraData={
              //   keys === "return" &&
              //   (formik?.values?.return_pod_number?.length === 0 ||
              //     formik?.values?.return_pod_number?.length ===
              //       +orderDetail?.pod) &&
              //   dialogSave?.check !== "overwrite"
              // }
              returnData={returnData}
              loadingDialog={loadingDialog}
              check={type}
              showCheck={keys}
              dialogConditionCheck={true}
              franchiseId={orderDetail?.franchise_id}
              orderDetail={orderDetail}
              accessAmount={accessAmount}
              setAccess={setAccess}
              dialogCondition={false}
              callPage={"collectionEdit"}
            />
          </form>
        </Modal.Body>
      </Modal>
      <DiscardDialog
        setDialogDis={setDialogSave}
        dialogDis={dialogSave}
        formik={formik}
        setActive={setDialog}
        type={"order"}
      />
      {snack.call ? <SnackBarTool {...snack} /> : ""}
    </>
  );
}
